/*
    Webchat input
*/

// Active - Inactive
var chatInputBtnActive = document.getElementById('chat-input-active');
var chatInputBtnInactive = document.getElementById('chat-input-inactive');
var chatInputContent = document.getElementById('chat-input-content');
chatInputBtnActive.addEventListener('click', function(){
    chatInputBtnActive.classList.add('selected');
    chatInputBtnInactive.classList.remove('selected');
    chatInputContent.style.display = "block";

    window.customStyle[".webchat-input"]["display"] = "block";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
chatInputBtnInactive.addEventListener('click', function(){
    chatInputBtnActive.classList.remove('selected');
    chatInputBtnInactive.classList.add('selected');
    chatInputContent.style.display = "none";

    window.customStyle[".webchat-input"]["display"] = "none";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Size
var sizeW = document.getElementById("chat-input-width");
sizeW.addEventListener("change", function(event){
    window.customStyle[".webchat-input"]["width"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var sizeH = document.getElementById("chat-input-height");
sizeH.addEventListener("change", function(event){
    window.customStyle[".webchat-input"]["height"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Position
window.selectAligmentChatInput = function(pos) {
    var leftAlignmentContainer = document.getElementsByClassName('chat-input-alignment-element-left')[0];
    var centerAlignmentContainer = document.getElementsByClassName('chat-input-alignment-element-center')[0];
    var rightAlignmentContainer = document.getElementsByClassName('chat-input-alignment-element-right')[0];
    if (pos == 'left') {
        leftAlignmentContainer.classList.add('selected');
        centerAlignmentContainer.classList.remove('selected');
        rightAlignmentContainer.classList.remove('selected');
        window.customStyle['.webchat-input']['align-self'] = "flex-start !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else if (pos == 'center') {
        leftAlignmentContainer.classList.remove('selected');
        centerAlignmentContainer.classList.add('selected');
        rightAlignmentContainer.classList.remove('selected');
        window.customStyle['.webchat-input']['align-self'] = "center !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else if (pos == 'right') {
        leftAlignmentContainer.classList.remove('selected');
        centerAlignmentContainer.classList.remove('selected');
        rightAlignmentContainer.classList.add('selected');
        window.customStyle['.webchat-input']['align-self'] = "flex-end !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    }
}

// Fill Color
var select = document.getElementById('chat-input-color-selector');
var colorPreview = document.getElementById('color-preview-chat-input');
window.updateChatInputColor = function() {
    select.replaceChildren();
    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    select.appendChild(option);

    colorPreview.style.backgroundColor = "transparent";
    colorPreview.style.border = "#5D5D5D 1px solid";
    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        select.appendChild(option);
    }
}
select.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {
            colorPreview.style.backgroundColor = val.settings.color;
            window.customStyle[".webchat-input"]["background"] = val.settings.color + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }

    if (event.target.value == "") {
        colorPreview.style.backgroundColor = "transparent";
        colorPreview.style.border = "#5D5D5D 1px solid";
        window.customStyle['.webchat-input']['background'] = "transparent !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        colorPreview.style.border = "transparent";
    }
});

// Text Color
var selectText = document.getElementById('chat-input-text-color-selector');
var colorPreviewText = document.getElementById('color-preview-text-chat-input');
window.updateChatInputColorText = function() {
    selectText.replaceChildren();
    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    selectText.appendChild(option);

    colorPreviewText.style.backgroundColor = "transparent";
    colorPreviewText.style.border = "#5D5D5D 1px solid";
    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        selectText.appendChild(option);
    }
}
selectText.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {
            colorPreviewText.style.backgroundColor = val.settings.color;
            window.customStyle[".webchat-input-message-input"]["color"] = val.settings.color + " !important";
            window.customStyle[".webchat-input-message-input::-webkit-input-placeholder"]["color"] = val.settings.color + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }

    if (event.target.value == "") {
        colorPreviewText.style.backgroundColor = "transparent";
        window.customStyle['.webchat-input-message-input']['color'] = "transparent !important";
        window.customStyle['.webchat-input-message-input::-webkit-input-placeholder']['color'] = "transparent !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    }
});

// Corner Radius
var cornerRadiusTopL = document.getElementById('corner-radius-topL-chat-input');
cornerRadiusTopL.addEventListener('change', function(event) {
    window.customStyle[".webchat-input"]["border-top-left-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var cornerRadiusTopR = document.getElementById('corner-radius-topR-chat-input');
cornerRadiusTopR.addEventListener('change', function(event) {
    window.customStyle[".webchat-input"]["border-top-right-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var cornerRadiusBottomR = document.getElementById('corner-radius-bottomR-chat-input');
cornerRadiusBottomR.addEventListener('change', function(event) {
    window.customStyle[".webchat-input"]["border-bottom-right-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var cornerRadiusBottomL = document.getElementById('corner-radius-bottomL-chat-input');
cornerRadiusBottomL.addEventListener('change', function(event) {
    window.customStyle[".webchat-input"]["border-bottom-left-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Border
var borderColor = "black";
var borderWidth = "1px";
var borderString = borderWidth + " solid " + borderColor;

var selectBorderPos = document.getElementById('chat-input-border-selector');
selectBorderPos.addEventListener('change', function(event) {
    if (event.target.value == "inside") {
        window.customStyle[".webchat-input"]["box-sizing"] = "border-box !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        window.customStyle[".webchat-input"]["box-sizing"] = "content-box !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    }
})

var selectBorder = document.getElementById('chat-input-border-color-selector');
var colorPreviewBorder = document.getElementById('color-border-preview-chat-input');
window.updateChatInputBorderColor = function() {
    selectBorder.replaceChildren();
    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    selectBorder.appendChild(option);

    colorPreviewBorder.style.backgroundColor = "transparent";
    colorPreviewBorder.style.border = "#5D5D5D 1px solid";
    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        selectBorder.appendChild(option);
    }
}
selectBorder.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {
            colorPreviewBorder.style.backgroundColor = val.settings.color;

            borderColor = val.settings.color;
            borderString = borderWidth + " solid " + borderColor;
            window.customStyle[".webchat-input"]["border"] = borderString + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
    if (event.target.value == "") {
        colorPreviewBorder.style.backgroundColor = "transparent";
        colorPreviewBorder.style.border = "#5D5D5D 1px solid";
        borderColor = "transparent";
        borderString = borderWidth + " solid " + borderColor;
        window.customStyle[".webchat-input"]["border"] = borderString + " !important";
        
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        colorPreviewBorder.style.border = "transparent";
    }
});

var widthBorder = document.getElementById('width-border-chat-input');
widthBorder.addEventListener('change', function(event) {
    borderWidth = event.target.value;
    borderString = borderWidth + " solid " + borderColor;
    window.customStyle[".webchat-input"]["border"] = borderString + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Shadow
var hOffset = "0px";
var vOffset = "0px";
var blurShadow = "0px";
var spreed = "0px";
var shadowColor = "#000";
var shadowPos = "";

var hOffsetElement = document.getElementById("chat-input-shadow-h-offset");
hOffsetElement.addEventListener("change", function(event) {

    hOffset = event.target.value;
    var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos + " !important";

    window.customStyle[".webchat-input"]["box-shadow"] = shadow;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var vOffsetElement = document.getElementById("chat-input-shadow-v-offset");
vOffsetElement.addEventListener("change", function(event) {

    vOffset = event.target.value;
    var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos + " !important";

    window.customStyle[".webchat-input"]["box-shadow"] = shadow;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var blurElement = document.getElementById("chat-input-shadow-blur");
blurElement.addEventListener("change", function(event) {

    blurShadow = event.target.value;
    var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos + " !important";

    window.customStyle[".webchat-input"]["box-shadow"] = shadow;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var spreedElement = document.getElementById("chat-input-shadow-spreed");
spreedElement.addEventListener("change", function(event) {

    spreed = event.target.value;
    var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos + " !important";

    window.customStyle[".webchat-input"]["box-shadow"] = shadow;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var selectShadow = document.getElementById('chat-input-shadow-color-selector');
var colorPreviewShadow = document.getElementById('color-shadow-preview-color-chat-input');
window.updateChatInputShadowColor = function() {
    selectShadow.replaceChildren();
    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    selectShadow.appendChild(option);

    colorPreviewShadow.style.backgroundColor = "transparent";
    colorPreviewShadow.style.border = "#5D5D5D 1px solid";
    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        selectShadow.appendChild(option);
    }
}
selectShadow.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {
            colorPreviewShadow.style.backgroundColor = val.settings.color;

            shadowColor = val.settings.color;
            var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos + " !important";
            window.customStyle[".webchat-input"]["box-shadow"] = shadow;
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
    if (event.target.value == "") {
        colorPreviewShadow.style.backgroundColor = "transparent";
        colorPreviewShadow.style.border = "#5D5D5D 1px solid";
        shadowColor = "transparent";
        var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos + " !important";
        window.customStyle['.webchat-input']['box-shadow'] = shadow;
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        colorPreviewShadow.style.border = "transparent";
    }
});

var shadowPosElement = document.getElementById("chat-input-shadow-position");
shadowPosElement.addEventListener("change", function(event) {
    if (event.target.value == "inner") {
        shadowPos = "inset";
    } else {
        shadowPos = "";
    }
    var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos + " !important";

    window.customStyle[".webchat-input"]["box-shadow"] = shadow;
    window.styleElement.textContent = window.css.of(window.customStyle);
})